import { Button, Icon, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Text, useDisclosure } from "@chakra-ui/react";
import HoverableIconButton from "components/Atomos/Buttons/HoverableIconButton";
import { useState } from "react";

import { FiTrash } from "react-icons/fi";

type DeleteButtonProps = {
    onConfirm: () => void | Promise<void>;
}

const DeleteButton = ({
    onConfirm,
}: DeleteButtonProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        isOpen,
        onClose,
        onOpen
    } = useDisclosure();

    const handleDeleting = async () => {
        setIsLoading(true);
        await onConfirm?.();
        onClose();
        setIsLoading(false);
    }

    return (
        <Popover returnFocusOnClose={false} isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
            <PopoverTrigger>
                <HoverableIconButton
                    label="Deseja apagar?"
                    icon={<Icon as={FiTrash} />}
                />
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader>
                    Apagar postagem?
                </PopoverHeader>
                <PopoverBody>
                    <Text whiteSpace="break-spaces">
                        Você tem certeza que deseja apagar essa postagem?
                        Essa ação não poderá ser desfeita. 
                        <br />
                        Deseja continuar?
                    </Text>
                </PopoverBody>
                <PopoverFooter>
                    <Button colorScheme="red" isLoading={isLoading} isFullWidth onClick={handleDeleting}>
                        Sim, apagar
                    </Button>
                </PopoverFooter>
            </PopoverContent>
        </Popover>

    )
}

export default DeleteButton